import { useContext } from "react";
import { BoxFull, InputTextarea } from "iuvity-ui-components";
import { AppContext } from "../../context/index";
import { PhoneNumberInput } from "iuvity-ui-components/dist/phonenumberinput";

interface CustomDetailBoxProps {
    fields: any;
    data: any;
    boxTitle?: string;
  }

export const CustomDetailBox: React.FC<CustomDetailBoxProps> = ({
    fields,
    data,
    boxTitle,
}) => {
    const {
        t,
        appState: { user },
        } = useContext(AppContext);

    return (
        <div className="custom-form-box-container mt-4">
            {
                boxTitle ?
                <div className="flex justify-content-center pl-8">
                    <p
                        className="boxTitle pl-5"
                        style={{
                            marginLeft: 'var(--space-xxl)',
                            width: '80rem'}}>
                        {boxTitle}
                    </p>
                </div> :
                null
            }
            <BoxFull className="dt-c mt-4 py-5 px-5 fields-main-container" style={{ backgroundColor: 'var(--cardBackgroundColorTwo)' }}>
                <div className="flex align-items-flex-start justify-content-flex-start flex-wrap fields-box">
                {data && (
                    <>
                    {fields?.map((property: any) => {
                        const newKey = property.key.split(".").pop();
                        return (
                        <div
                            key={`c-${property.key}`}
                            className="flex flex-column mb-4"
                            style={{ width: "40%" }}
                        >
                            {
                                property.type === 'textarea' ?
                                    <InputTextarea
                                        id={`input-${newKey}`}
                                        key={newKey}
                                        className={"input-md"}
                                        label={t(`PointsOfAttention.${newKey}Label`)}
                                        value={data[newKey]}
                                        placeholder={t(`PointsOfAttention.${newKey}Placeholder`)}
                                        autoComplete="off"
                                        readOnly
                                        autoResize
                                        style={{
                                        width: "20rem",
                                        }}
                                    /> :
                                property.type === 'phone' ?
                                <PhoneNumberInput
                                    country = 'co'
                                    localization={localStorage.getItem('LANGUAGE') || 'en'}
                                    label={t(`PointsOfAttention.${newKey}Label`)}
                                    placeholder={t(`PointsOfAttention.${newKey}Placeholder`)}
                                    searchPlaceholder={t("TableHeader.searchPlacehoder")}
                                    preferredCountries={['co', 'ec']}
                                    // @ts-ignore
                                    value={data[newKey]}
                                    readOnly
                                /> :
                                <div
                                    className="flex flex-column gap-2 mt-1"
                                    style={{ marginBottom: 0, width: '328px' }}
                                >
                                    <label className="block ibp-input-label " htmlFor={`input-${newKey}`}>
                                        {t(`PointsOfAttention.${newKey === 'pointServiceType' ? 'typeOfPointAttention' : newKey}Label`)}
                                    </label>
                                    <p className="flex justify-content-between">
                                        {data[newKey] || '' }
                                        {
                                            property.type === 'calendar'
                                            && <i className="iu iu-icon-calendar pr-8 mr-7" />
                                        }    
                                    </p>
                                </div>
                            }
                        </div>
                        );
                    })}
                    </>
                )}
                </div>
            </BoxFull>
        </div>
    )
}